// src/services/tokenFetcher/arbitrumTokenFetcher.js
import secureFetch from '../../utils/secureFetch';

/**
 * Fetch tokens for an Arbitrum wallet using the Routescan API.
 * Transforms the response to match the expected format in Wallet.js
 *
 * @param {string} walletAddress - The wallet address to query
 * @returns {Promise<Array>} - A promise that resolves to an array of token objects in the expected format
 */
export const fetchTokens = async (walletAddress) => {
    try {
      const response = await secureFetch(`https://api.routescan.io/v2/network/mainnet/evm/42161/address/${walletAddress}/erc20-holdings?limit=25`);
      const data = await response.json();
      
      // Check if the response has the expected structure
      if (!data || !Array.isArray(data.items)) {
        console.error("Unexpected API response format:", data);
        return [];
      }
      
      // Transform the data to match the expected format in Wallet.js
      return data.items.map(item => {
        return {
          token: {
            type: "ERC-20",
            address: item.tokenAddress,
            name: item.tokenName,
            symbol: item.tokenSymbol,
            decimals: item.tokenDecimals
          },
          value: item.tokenQuantity || "0",
          // Additional properties that might be useful
          usdValue: item.tokenValueInUsd || "0",
          price: item.tokenPrice || "0"
        };
      });
    } catch (error) {
      console.error("Error fetching Arbitrum tokens:", error);
      return [];
    }
  };